import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Chain } from '~/types';

interface ValidationState {
  validatedAddresses: {
    [chatId: string]: {
      [addressKey: string]: {
        isValid: boolean;
        isPending: boolean;
      };
    };
  };
}

const initialState: ValidationState = {
  validatedAddresses: {},
};

const getCacheKey = (address: string, chainType: Chain) =>
  `${address}-${chainType}`;

export const validationSlice = createSlice({
  name: 'validation',
  initialState,
  reducers: {
    setPendingValidation: (
      state,
      action: PayloadAction<{
        chatId: string;
        address: string;
        chainType: Chain;
      }>,
    ) => {
      const { chatId, address, chainType } = action.payload;
      const addressKey = getCacheKey(address, chainType);

      if (!state.validatedAddresses[chatId]) {
        state.validatedAddresses[chatId] = {};
      }

      if (!state.validatedAddresses[chatId][addressKey]?.isValid) {
        state.validatedAddresses[chatId][addressKey] = {
          isValid: false,
          isPending: true,
        };
      }
    },

    setCacheResult: (
      state,
      action: PayloadAction<{
        chatId: string;
        address: string;
        chainType: Chain;
        isValid: boolean;
      }>,
    ) => {
      const { chatId, address, chainType, isValid } = action.payload;
      const addressKey = getCacheKey(address, chainType);

      if (!state.validatedAddresses[chatId]) {
        state.validatedAddresses[chatId] = {};
      }

      state.validatedAddresses[chatId][addressKey] = {
        isValid,
        isPending: false,
      };
    },

    clearChatValidations: (
      state,
      action: PayloadAction<{ chatId: string }>,
    ) => {
      const { chatId } = action.payload;
      if (state.validatedAddresses[chatId]) {
        delete state.validatedAddresses[chatId];
      }
    },

    clearAllValidations: (state) => {
      state.validatedAddresses = {};
    },
  },
});

export const {
  setPendingValidation,
  setCacheResult,
  clearChatValidations,
  clearAllValidations,
} = validationSlice.actions;

export const validationReducer = validationSlice.reducer;
